import { KasaVirmanislemiPage } from './../kasa-virmanislemi/kasa-virmanislemi';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../../providers/ortak';
import { KasaeklePage } from './../../../Yonetim/KasaIslemleri/kasaekle/kasaekle';
import { Component } from '@angular/core';
import { NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { BllOrtak } from '../../../../providers/bll/bll-ortak';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';

/**
 * Generated class for the KasalistePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kasaliste',
  templateUrl: 'kasaliste.html',
})
export class KasalistePage {
  aranan="";
  skip:number=0;
  take:number=50;
  KasaListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "KasaListesi","", true).then(a => {
     
      var sonuc = <any>a;
      this.KasaListesi = sonuc.SonucObject;
     
   
 
    })
  }
  
  kasakayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(KasaeklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  Kasaduzenle(kasa){
    let modal = this.modalCtrl.create(KasaeklePage, { KasaVw: kasa });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
  Virman(){
    let modal = this.modalCtrl.create(KasaVirmanislemiPage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
  
  }
  KasaSil(kasa) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("Kasa_json", kasa.ID);
     

      this.bllOrtak.islem(formData, "KasaSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }
  Islemler(kasa) {
    const actionSheet = this.actionSheetCtrl.create({
      title: kasa.Name +" "+"Kasası",
      buttons: [
        {
          text: 'Sil',

          handler: () => {
            this.KasaSil(kasa);
          }

        },
        {
          text: 'Virman Yap',
          handler: () => {
            this.Virman();
          }
        },
        {
          text: 'Düzenle',
          handler: () => {
            this.Kasaduzenle(kasa);
          }
        }, {
          text: 'İptal ',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    actionSheet.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/KasaIslemleri/kasaliste/kasaliste.ts